import React, { useCallback } from "react";
import Checkbox from "@ui-kit/form/checkbox";
import Line from "@radarly/components/panels/card-edition/sidebar/line";
import Radios from "@radarly/components/panels/card-edition/sidebar/radios";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { DateTermCard } from "@radarly/models/cards";
import {
  DatavizStackedBarChart,
  updateDatavizOptions,
} from "@radarly/models/dataviz";
import TimeUnitOption from "@radarly/shared/panels/card-edition/sidebar/shared/time-unit";

export interface SharedPanelsCardEditionSidebarOptionsStackedBarChartProps {
  dataviz: DatavizStackedBarChart;
  setDataviz: (dataviz: DatavizStackedBarChart) => void;
  card: DateTermCard;
  setCard: (card: DateTermCard) => void;
}

export default function SharedPanelsCardEditionSidebarOptionsStackedBarChart({
  dataviz,
  setDataviz,
  card,
  setCard,
}: SharedPanelsCardEditionSidebarOptionsStackedBarChartProps) {
  const locale = useCurrentUserLocale();
  const options = [
    { value: "true", label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::YES") },
    { value: "false", label: tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::NO") },
  ];

  const updateDisplayVolumes = useCallback(() => {
    const value = dataviz.displayVolumes ? false : true;
    setDataviz(
      updateDatavizOptions(
        dataviz,
        "displayVolumes",
        value as DatavizStackedBarChart["displayVolumes"]
      )
    );
  }, [dataviz, setDataviz]);

  return (
    <>
      <Radios
        label={tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::NORMALIZE_BARS")}
        options={options}
        value={String(!!dataviz.normalized)}
        onChange={(id) =>
          setDataviz(updateDatavizOptions(dataviz, "normalized", id === "true"))
        }
      />
      <Line title={tr(locale, "CUSTOM_PAGES::EDITOR::CARD_LEGEND")}>
        <Checkbox
          label={tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::DISPLAY_VOLUMES")}
          checked={dataviz.displayVolumes || undefined}
          onClick={updateDisplayVolumes}
        />
      </Line>
      <TimeUnitOption dataviz={dataviz} card={card} setCard={setCard} />
    </>
  );
}
